var exports = {
  "h": "workbenchSurface__OD2HmI",
  "Yt": "headerSlot__BiovDJ",
  "lA": "headerMount__zN7d6E",
  "wm": "paddedHeader__fvjDl1",
  "Wu": "workbenchLayout__2ZzafY",
  "qy": "contentColumn__ewkWeW",
  "Kj": "workbenchOpen__S8ddus",
  "sz": "expanded__cki_eL",
  "Og": "workbenchColumn__2GW7uS",
  "Di": "resizeHandle__74RFrP",
  "Gv": "explorer__ZAw0JZ",
  "L5": "explorerHeaderRow__4Qctd1",
  "eJ": "explorerRepositoryButton__rrInYJ",
  "cO": "explorerCloseButton__REb2wS",
  "i_": "workbenchFallback__IN_tsM",
  "zK": "previewOpen__WaPj5E",
};

module.exports = exports;
